import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/_helpers/auth.guard';

const routes: Routes = [
  { path: '',
    redirectTo: localStorage.getItem('currentUser') === null ? 'home' : 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'welcome',
    loadChildren: () => import('./pages/welcome/welcome.module').then( m => m.WelcomePageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'dashboard', canActivate: [AuthGuard],
    loadChildren: () => import('./pages/dashboard/dashboard.module').then( m => m.DashboardPageModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
  {
    path: 'cashiers', canActivate: [AuthGuard],
    loadChildren: () => import('./pages/cashiers/cashiers.module').then( m => m.CashiersPageModule)
  },
  {
    path: 'profile', canActivate: [AuthGuard],
    loadChildren: () => import('./pages/profile/profile.module').then( m => m.ProfilePageModule)
  },
  {
    path: 'new-payment', canActivate: [AuthGuard],
    loadChildren: () => import('./pages/new-payment/new-payment.module').then( m => m.NewPaymentPageModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./pages/signup/signup.module').then( m => m.SignupPageModule)
  },
  {
    path: 'withdraw', canActivate: [AuthGuard],
    loadChildren: () => import('./pages/withdraw/withdraw.module').then( m => m.WithdrawPageModule)
  },
  {
    path: 'notifications',
    loadChildren: () => import('./pages/notifications/notifications.module').then( m => m.NotificationsPageModule)
  },
  {
    path: 'create-dispute',
    loadChildren: () => import('./pages/create-dispute/create-dispute.module').then( m => m.CreateDisputePageModule)
  },
  {
    path: 'not-allowed',
    loadChildren: () => import('./shared/modals/not-allowed/not-allowed.module').then( m => m.NotAllowedPageModule)
  },
  {
    path: 'confirm-payment', canActivate: [AuthGuard],
    loadChildren: () => import('./pages/confirm-payment/confirm-payment.module').then( m => m.ConfirmPaymentPageModule)
  },
  {
    path: 'demo/payment',
    loadChildren: () => import('./pages/demo/payment/payment.module').then( m => m.PaymentPageModule)
  },
  {
    path: 'demo/confirm',
    loadChildren: () => import('./pages/demo/confirm/confirm.module').then( m => m.ConfirmPageModule)
  },
  {
    path: 'terms',
    loadChildren: () => import('./shared/modals/terms/terms.module').then( m => m.TermsPageModule)
  },
  {
    path: 'privacy',
    loadChildren: () => import('./shared/modals/privacy/privacy.module').then( m => m.PrivacyPageModule)
  },
  {
    path: 'managers',
    loadChildren: () => import('./pages/managers/managers.module').then( m => m.ManagersPageModule)
  },
  {
    path: 'add-manager',
    loadChildren: () => import('./shared/modals/add-manager/add-manager.module').then( m => m.AddManagerPageModule)
  },
  {
    path: 'user-permissions',
    loadChildren: () => import('./shared/modals/user-permissions/user-permissions.module').then( m => m.UserPermissionsPageModule)
  },
  {
    path: 'verify-email',
    loadChildren: () => import('./pages/verify-email/verify-email.module').then( m => m.VerifyEmailPageModule)
  },
  {
    path: 'add-cashier',
    loadChildren: () => import('./shared/modals/add-cashier/add-cashier.module').then( m => m.AddCashierPageModule)
  },
  {
    path: 'withdrawal-history', canActivate: [AuthGuard],
    loadChildren: () => import('./pages/withdrawal-history/withdrawal-history.module').then( m => m.WithdrawalHistoryPageModule)
  },
  {
    path: 'transactions', canActivate: [AuthGuard],
    loadChildren: () => import('./pages/transactions/transactions.module').then( m => m.TransactionsPageModule)
  },
  {
    path: 'filter-transactions', canActivate: [AuthGuard],
    loadChildren: () => import('./shared/modals/filter-transactions/filter-transactions.module')
    .then( m => m.FilterTransactionsPageModule)
  },
  {
    path: 'reports', canActivate: [AuthGuard],
    loadChildren: () => import('./pages/reports/reports.module').then( m => m.ReportsPageModule)
  },
  {
    path: 'select-payment-method',
    loadChildren: () => import('./shared/modals/select-payment-method/select-payment-method.module')
    .then( m => m.SelectPaymentMethodPageModule)
  },
  {
    path: 'withdrawal-receipt',
    loadChildren: () => import('./shared/modals/withdrawal-receipt/withdrawal-receipt.module').then( m => m.WithdrawalReceiptPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/homepage/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'faq',
    loadChildren: () => import('./pages/homepage/faq/faq.module').then( m => m.FaqPageModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./pages/homepage/privacy-policy/privacy-policy.module').then( m => m.PrivacyPolicyPageModule)
  },
  {
    path: 'password-reset',
    loadChildren: () => import('./pages/password-reset/password-reset.module').then( m => m.PasswordResetPageModule)
  },
  {
    path: 'upgrade-account', canActivate: [AuthGuard],
    loadChildren: () => import('./pages/upgrade-account/upgrade-account.module').then( m => m.UpgradeAccountPageModule)
  },
  {
    path: 'select-accounts',
    loadChildren: () => import('./shared/modals/select-accounts/select-accounts.module').then( m => m.SelectAccountsPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
